export function PhoneSvgIcon() {
  return (
    <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="52" height="52" rx="16" fill="#F3F2FC" />
      <path
        d="M28.8992 19.7999C28.8992 20.467 28.4196 21.2996 27.5 21.2999H24.5C23.5801 21.2999 23.0996 20.4671 23.0996 19.7999V17.9999C23.0996 17.5028 23.5026 17.0999 23.9996 17.0999C24.4967 17.0999 24.8996 17.5028 24.8996 17.9999V19.4999H27.0992V17.9999C27.0992 17.5029 27.5023 17.1001 27.9992 17.0999C28.4963 17.0999 28.8992 17.5028 28.8992 17.9999V19.7999Z"
        fill="#3E3DA7"
      />
      <path
        d="M27.1191 30.5999L27.2117 30.6045C27.6655 30.6506 28.0191 31.0339 28.0191 31.4999C28.0191 31.9658 27.6655 32.3491 27.2117 32.3952L27.1191 32.3999H24.8797C24.3826 32.3999 23.9797 31.9969 23.9797 31.4999C23.9797 31.0028 24.3826 30.5999 24.8797 30.5999H27.1191Z"
        fill="#3E3DA7"
      />
      <path
        d="M30.0992 20.0002C30.0992 19.3924 29.6078 18.9001 29 18.8999H23C22.3921 18.8999 21.8996 19.3923 21.8996 20.0002V32.0002C21.8998 32.608 22.3922 33.0995 23 33.0995H29C29.6076 33.0993 30.099 32.6079 30.0992 32.0002V20.0002ZM31.8992 32.0002C31.899 33.602 30.6017 34.8993 29 34.8995H23C21.3981 34.8995 20.0998 33.6021 20.0996 32.0002V20.0002C20.0996 18.3982 21.3979 17.0999 23 17.0999H29C30.6019 17.1001 31.8992 18.3983 31.8992 20.0002V32.0002Z"
        fill="#3E3DA7"
      />
    </svg>
  );
}
